import {IconProps} from "../../types/IconProps";

export const UtilityIcon = ({ width = 800, color = '#000'}: IconProps) => {
    return (
        <svg width={`${width}px`} height={`${width}px`} viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Icon-Set-Filled" transform="translate(-571.000000, -310.000000)" fill={color}>
                    <path d="M600.159,315.37 C599.653,315.938 598.813,316.661 597.609,317.762 C596.334,319.034 594.529,319.034 593.254,317.762 C591.978,316.488 591.978,314.688 593.254,313.415 C594.429,312.242 595.692,310.853 595.672,310.847 C592.257,309.274 588.082,309.882 585.268,312.69 C582.703,315.249 581.972,318.935 583.051,322.146 L572.2,332.976 C570.596,334.576 570.596,337.171 572.2,338.771 C573.804,340.371 576.404,340.371 578.008,338.771 L588.858,327.942 C592.078,329.021 595.771,328.289 598.336,325.73 C601.146,322.925 601.73,318.775 600.159,315.37" id="tools">
                    </path>
                </g>
            </g>
        </svg>
    )
}